(() => {
  const namespace = '__purchaseVisitClockV1';
  if (window[namespace]) {
    window[namespace].scan();
    return;
  }
  const duration = 15 * 60 * 60 * 1000;
  let endAt = Date.now() + duration;
  let interval;
  const clocks = new Map();

  function stop() {
    if (interval !== undefined) window.clearInterval(interval);
    interval = undefined;
  }

  function update() {
    const left = Math.max(0, Math.ceil((endAt - Date.now()) / 1000));
    const values = [Math.floor(left / 3600), Math.floor(left % 3600 / 60), left % 60];
    clocks.forEach((clock, root) => {
      if (!root.isConnected) {
        clocks.delete(root);
        return;
      }
      clock.cells.forEach((cell, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (cell.textContent !== value) cell.textContent = value;
      });
      clock.digits.hidden = false;
      root.dataset.visitClockEnd = String(endAt);
      root.dataset.visitClockComplete = String(left === 0);
    });
    if (left === 0 || clocks.size === 0) stop();
  }

  function scan() {
    document.querySelectorAll('[data-visit-clock]').forEach(root => {
      if (clocks.has(root)) return;
      const digits = root.querySelector('[data-visit-digits]');
      const cells = ['hours', 'minutes', 'seconds'].map(name => root.querySelector(`[data-visit-time="${name}"]`));
      if (!digits || cells.some(cell => !cell)) return;
      clocks.set(root, { digits, cells });
      const link = root.querySelector('[data-lcbf-offers]');
      if (link && !root.dataset.visitLinkReady) {
        root.dataset.visitLinkReady = 'true';
        link.addEventListener('click', event => {
          const offers = document.querySelector('#MainContent quantity-breaks');
          if (!offers) return;
          event.preventDefault();
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          offers.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          const selected = offers.querySelector('input[type="radio"]:checked');
          if (selected) selected.focus({ preventScroll: true });
        });
      }
    });
    update();
    if (interval === undefined && clocks.size > 0 && Date.now() < endAt) {
      interval = window.setInterval(update, 1000);
    }
  }

  window[namespace] = { scan };
  document.addEventListener('visibilitychange', scan);
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => {
    if (event.persisted) endAt = Date.now() + duration;
    scan();
  });
  scan();
})();
